import React, { useEffect } from 'react';

import R from 'ramda';

import { CircularProgressbar, buildStyles } from 'react-circular-progressbar';
import 'react-circular-progressbar/dist/styles.css';

import Image from 'react-bulma-companion/lib/Image';

import check from '_assets/icons/check.svg';

export default function ProgressChart({ progress, survey_meta, title }) {
  const survey_sections = Array.from(survey_meta.sections);
  useEffect(() => {
    console.log(title, survey_meta, survey_sections)
  }, [])

  return (
    <div className='progress_chart-wrapper'>
      <div className='progress_chart'>
        <div className='progress_bar-container'>
          <div className='progress_bar-progress' style={{ height: `${132 + (84 * R.indexOf(title.section, survey_sections))}px` }}></div>
        </div>
        <div className='steps'>
          {R.reverse(survey_sections).map((s, index) => <div className={`step${s == title.section ? ' active' : ''}${R.indexOf(title.section, survey_sections) > (survey_sections.length - index - 1) ? ' passed' : ''}`} key={s}>
            <p className='step-number'>Step {(survey_sections.length - index)}</p>

            {s == title.section && <>
              <p className='step-title'>{s}</p>
              <p className='step-name'>{title.name}</p>
            </>}
          </div>)}
        </div>
      </div>
    </div>
  );
}
